import {
  BASE_PRICING,
  SIZE_MULTIPLIER,
  DESIGN_MULTIPLIER,
  TIMELINE_MULTIPLIER,
  FEATURE_COSTS,
  ADMIN_COST,
  EXTRA_ROLE_COST,
} from "./pricingConfig";

export const calculateProjectCost = (data) => {
  const base = BASE_PRICING[data.projectType];
  if (!base) return null;

  let min = base.baseMin;
  let max = base.baseMax;

  // Size
  const sizeMultiplier = SIZE_MULTIPLIER[data.projectSize] || 1;
  min *= sizeMultiplier;
  max *= sizeMultiplier;

  // Design
  const designMultiplier = DESIGN_MULTIPLIER[data.designLevel] || 1;
  min *= designMultiplier;
  max *= designMultiplier;

  // Pages impact
  if (data.pages > 10) {
    min *= 1.15;
    max *= 1.25;
  }
  if (data.pages > 25) {
    min *= 1.35;
    max *= 1.5;
  }

  // Features
  let featureCost = 0;
  (data.features || []).forEach((key) => {
    featureCost += FEATURE_COSTS[key] || 0;
  });

  min += featureCost;
  max += featureCost * 1.2;

  // Admin & roles
  if (data.roles?.includes("admin")) {
    min += ADMIN_COST;
    max += ADMIN_COST * 1.2;
  }

  if (data.roles?.includes("multiple")) {
    min += EXTRA_ROLE_COST;
    max += EXTRA_ROLE_COST * 1.2;
  }

  // Timeline
  const timelineMultiplier = TIMELINE_MULTIPLIER[data.timeline] || 1;
  min *= timelineMultiplier;
  max *= timelineMultiplier;

  return {
    min: Math.round(min),
    max: Math.round(max),
    currency: "USD",
  };
};
